<template>
  <v-banner class="custom-plan-banner">
    {{ $t('overview.custom.text') }}
    <template v-slot:actions>
      <v-btn
        text
        @click="openCustomPlanDialog"
      >
        {{ $t('overview.custom.link') }}
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
export default {
  name: 'CustomPlanBanner',
  methods: {
    openCustomPlanDialog() {
      this.$store.dispatch('main/openDialog', 'customPlanMoreProfiles')
    }
  }
}
</script>

<style lang="scss">
  .custom-plan-banner.theme--light.v-banner.v-sheet:not(.v-sheet--outlined):not(.v-sheet--shaped),
  .custom-plan-banner.v-banner {
    padding: 0;
    margin: 8px 0;

    .v-sheet:not(.v-sheet--outlined):not(.v-sheet--shaped) .v-banner__wrapper,
    .v-banner__wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 16px 16px 16px 16px;
      gap: 24px;
      border-radius: 6px;
      background-image: url('~@/assets/customPlanBannerBackground.svg');
      border-bottom: none;

      .v-banner__text {
        color: var(--v-text-primary-base);
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
      }

      .v-banner__content {
        max-width: max-content;
        padding: 0;
      }

      .v-banner__actions {
        padding: 0;
        margin-bottom: 0;
        max-width: max-content;


        .v-btn,
        .v-btn:not(.v-btn--round).v-size--default {
          height: max-content;
        }

        .v-btn {
          padding: 0;

          .v-btn__content {
            color: var(--v-link-primary-text-default-base);
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            text-transform: none;
            border-bottom: 1px solid var(--v-link-primary-border-default-base);
            letter-spacing: normal;
          }

          .v-ripple__container {
            background: transparent;
            opacity: 0;
          }

          &:focus::before,
          &:hover::before {
            opacity: 0;
          }
        }
      }
    }
  }
</style>